/**
 * Reportes — shell con tabs lineales que también funcionan como rutas.
 *
 * Cada sub-vista vive en una ruta hermana (/reportes/movimientos,
 * /reportes/cruce, /reportes/destrucciones). La sidebar entra directo a la
 * sub-ruta; al estar adentro, esta cabecera permite saltar entre tabs sin
 * volver al sidebar.
 */

import { NavLink, Outlet } from 'react-router-dom';
import { FileText, GitCompare, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const TABS = [
  { to: '/reportes/movimientos', label: 'Movimientos', icon: FileText },
  { to: '/reportes/cruce', label: 'Cruce ERP ↔ SNT', icon: GitCompare },
  { to: '/reportes/destrucciones', label: 'Destrucciones', icon: Trash2 },
] as const;

export function ReportesShell() {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-everex-azul">Reportes</CardTitle>
          <p className="text-xs text-gray-600">
            Consultas read-only sobre movimientos, cruces ERP↔SNT y destrucciones.
          </p>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-2 border-b border-gray-200">
            {TABS.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                className={({ isActive }) =>
                  cn(
                    'px-4 py-2 text-sm transition',
                    isActive
                      ? 'border-b-2 border-everex-naranja font-semibold text-everex-azul'
                      : 'text-gray-600 hover:text-everex-azul',
                  )
                }
              >
                <t.icon className="mr-1 inline h-4 w-4" />
                {t.label}
              </NavLink>
            ))}
          </div>
        </CardContent>
      </Card>

      <Outlet />
    </div>
  );
}
